import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import dataModel from '../../../../models/DataModel';
import barcode from '../../../../assets/images/inventory-barcode.svg';
import trash from '../../../../assets/images/trash.svg';

import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';

import './InventoryEdit.scss';
import Input from '../../../../components/Input';
class InventoryEdit extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { 
      editInventoryItem: { company_id: this.props.currentCompany ? this.props.currentCompany.id : null, name: '', identifier: '' },
    };

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.queryDelete = this.queryDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.editInventoryItem) {
      this.setState({ editInventoryItem: Object.assign({}, this.props.editInventoryItem) });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editInventoryItem != this.props.editInventoryItem && this.props.editInventoryItem) {
      this.setState({ editInventoryItem: Object.assign({}, this.props.editInventoryItem) });
    }
  }

  handleCancel() {
    this.props.history.goBack();
  }

  async handleSave() {
    if (this.props.forEdit) {
      this.analyticsLogger.logInventoryEvent('EditInventory');
      await dataModel.inventoryItemsDAO.updateInventoryItem(this.state.editInventoryItem, this.props.task.id);
    }
    else {
      this.analyticsLogger.logInventoryEvent('AddInventory');
      await dataModel.inventoryItemsDAO.createInventoryItem(this.state.editInventoryItem, this.props.task.id);
    }
    this.handleCancel();
  }
  
  doDelete() {
    this.analyticsLogger.logInventoryEvent('DeleteInventory');
    dataModel.inventoryItemsDAO.deleteInventoryItem(this.state.editInventoryItem, this.props.task.id).then(() => {
      this.handleCancel();
    });
  }

  queryDelete() {
    let message = `Are you sure you want to delete inventory item Inventory ${this.state.editInventoryItem.name}? This action cannot be undone.`;
    
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      cancelButtonText: 'CANCEL', 
      okButtonText: 'YES',
      width: 300, 
      height: 175, 
      message: message,
      handleOwnerOk: () => {
        this.doDelete();
      }, 
    });
  }

  handleIdChange(e) {
    let editedInventory = Object.assign({}, this.state.editInventoryItem);
    editedInventory.identifier = e.target.value;
    this.setState({ editInventoryItem: editedInventory, canSave: (editedInventory.name && editedInventory.identifier) });
  }
  
  handleNameChange(e) {
    let editedInventory = Object.assign({}, this.state.editInventoryItem);
    editedInventory.name = e.target.value;
    this.setState({ editInventoryItem: editedInventory, canSave: (editedInventory.name && editedInventory.identifier) });
  }
  
  convertTaskStatus(task){
    return task.status.split('_').map(word => word.substr(0,1).toUpperCase() + word.substr(1).toLowerCase()).join(' ');
  }

  handleScan() {
    window.plugins.BarcodeScanner.scan(      
      result => {
        let editedInventory = Object.assign({}, this.state.editInventoryItem);
        editedInventory.identifier = result.text;
        this.analyticsLogger.logInventoryEvent('ScanBarcode');
        this.setState({ editInventoryItem: editedInventory, canSave: (editedInventory.name && editedInventory.identifier) });
      }, error => {
      throw new Error(error);
    }, {
      preferFrontCamera: false, // iOS and Android
      showFlipCameraButton: true, // iOS and Android
      showTorchButton: true, // iOS and Android
      torchOn: false, // Android, launch with the torch switched on (if available)
      saveHistory: true, // Android, save scan history (default false)
      prompt: 'Place a barcode inside the scan area', // Android
      resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
      //formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
      orientation: 'portrait', // Android only (portrait|landscape), default unset so it rotates with the device
      disableAnimations: true, // iOS
      disableSuccessBeep: false, // iOS and Android
    });
  }

  render() {
    const { task } = this.props;
    if (!task){
      return null;
    }

    let attachmentCount = task.task_attachments_count;
    const total = task.completion_criteria ? task.completion_criteria.length : 0;
    let completed = 0;
    if (total > 0) {
      completed = task.completion_criteria.filter(cc => {
        return cc && cc.completed_at;
      }).length;
    }
    let status = this.convertTaskStatus(task);

    return (

        <div className="inventory-edit-container" >
          <div >
          <div className='task-details'>
            <img className={'delete-item' + (this.props.forEdit ? ' editing' : '')} onClick={this.queryDelete} alt="delete" src={trash}/>
            <div className="task-name">{task.name}</div>
            <div className="project-name">{task.project ? task.project.name : 'No project name'}</div>
            <div className='details-bottom-row'>
              <div className='attachment-icon' />
              <div className='attachments'>{attachmentCount}</div>
              <div className='completion-icon' />
              <div className='completion-steps'>{`${completed}/${total}`}</div>
              <div className={`status ${task.status}`}>{status}</div>
            </div>
          </div>
        </div>
        <div className="inventory-edit">
          <div className="inventory-edit__title">INVENTORY MANAGEMENT</div>
          <div className="inventory-edit__barcode-container">
            <img className="barcode-image" alt="barcode" src={barcode} onClick={this.handleScan} />
          </div>
          <div className="inventory-edit__entry-fields">
            <div className="entry-field">
              <div className="label">INVENTORY ID</div>
              <Input className="field id-field" placeholder="Enter Inventory ID" value={this.state.editInventoryItem.identifier} onChange={this.handleIdChange}/>
            </div>
            <div className="entry-field">
              <div className="label">INVENTORY NAME</div>
              <Input className="field name-field" placeholder="Enter Inventory Name" value={this.state.editInventoryItem.name} onChange={this.handleNameChange}/>
              {/* Buttons are nested for absolute positioning */}
              <div className="inventory-edit__buttons">
                <div className="cancel-button" onClick={this.handleCancel}>CANCEL</div>
                <div className={'add-button' + (this.state.canSave ? ' can-save' : '')} onClick={this.state.canSave ? this.handleSave : null}>{this.props.forEdit ? 'SAVE': 'ADD'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};
export default withRouter(connect(mapStateToProps)(InventoryEdit));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/InventoryEdit/index.js